import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import $ from "jquery";
import "datatables.net-bs4";
import { UserContext } from "../../App";
import { deleteEvent, useEvents } from "../../utils/event";
import { verifyRight } from "../../utils/users";
import { StyledTr } from "./bookingContent";
import ActionsMenu from "../layout/ActionsMenu";
import TrashIcon from "../icons/TrashIcon";
import SelectionActionsPopup from "../layout/SelectionActionsPopup";
import { OutlineButtonLink } from "../layout/OutlineButton";

export default function EventsContent() {
  const { userInfos } = useContext(UserContext);
  const [checked, setChecked] = useState([]);
  const { events, loaded } = useEvents();
  const datatable = useRef(null);

  useEffect(() => {
    if (!loaded) return;
    if (datatable.current) {
      datatable.current.destroy();
      datatable.current = null;
    }

    window.setTimeout(() => {
      datatable.current = $("#datatable").DataTable({
        retrieve: true,
        order: [[1, "asc"]],
        pageLength: 25,
      });
    }, 1);
  }, [events, loaded]);

  function handleCheckbox(e) {
    const { value, checked: isChecked } = e.target;
    if (isChecked) {
      setChecked((old) => [...old, value]);
    } else {
      setChecked((old) => old.filter((id) => id !== value));
    }
  }

  const DatatableContent = useMemo(
    () => (
      <tbody>
        {events.map((event, index) => {
          let actions = [];

          if (verifyRight(userInfos, "event", "update")) {
            actions.push({
              label: "Modifier",
              link: `/events/${event.id}`,
            });
          }

          if (verifyRight(userInfos, "event", "delete")) {
            actions.push({
              label: "Supprimer",
              onClick: async () => {
                if (
                  !window.confirm(
                    "Voulez-vous vraiment supprimer cet évènement ?"
                  )
                )
                  return;
                await deleteEvent(userInfos, [event.id]);
                window.location.reload();
              },
            });
          }

          return (
            <StyledTr
              key={event.id}
              className={checked.includes(event.id) ? "checked" : ""}
            >
              <td style={{ textAlign: "center" }}>
                <input
                  type="checkbox"
                  name="bulk_action"
                  value={event.id}
                  checked={checked.includes(event.id)}
                  onChange={handleCheckbox}
                />
              </td>
              <td>{index + 1}</td>
              <td>{event.name || "N/A"}</td>
              <td>{event?.provider?.name || "N/A"}</td>
              <td>
                <ActionsMenu items={actions} />
              </td>
            </StyledTr>
          );
        })}
      </tbody>
    ),
    [events, userInfos, checked]
  );

  const handleDeleteEvent = useCallback(async () => {
    if (checked.length) {
      if (!window.confirm("Voulez-vous vraiment supprimer ces évènements ?"))
        return;
      await deleteEvent(userInfos, checked);
      window.location.reload();
    }
  }, [checked, userInfos]);

  const PortletFooter = useMemo(() => {
    if (checked.length) {
      let actions = [];

      if (verifyRight(userInfos, "event", "delete")) {
        actions.push({
          label: <TrashIcon />,
          onClick: handleDeleteEvent,
        });
      }

      return (
        <SelectionActionsPopup
          items={[]}
          selectedItemsLength={checked.length}
          resetChecked={() => setChecked([])}
          buttons={actions}
        />
      );
    }
  }, [checked.length, handleDeleteEvent, userInfos]);

  return (
    <div className="body-container">
      <div className="title-container">
        <h3 className="title">Evènements</h3>
        <div className="header-toolbar">
          {verifyRight(userInfos, "event", "create") && (
            <OutlineButtonLink to="/addEvents/">
              <i className="la la-plus"></i>
              Nouvel évènement
            </OutlineButtonLink>
          )}
        </div>
      </div>

      <div className="kt-container--fluid kt-grid__item kt-grid__item--fluid">
        <div>
          <div className="kt-portlet__body" style={{ overflowX: "scroll" }}>
            <table
              className="table table-striped- table-bordered table-hover table-checkable"
              id="datatable"
            >
              <thead>
                <tr>
                  <th
                    style={{ width: "5%", textAlign: "center" }}
                    data-sort="false"
                  >
                    Selection
                  </th>
                  <th style={{ width: "5%" }}>#</th>
                  <th style={{ width: "30%" }}>Nom</th>
                  <th style={{ width: "30%" }}>Client</th>
                  <th style={{ width: "10%" }}>Actions</th>
                </tr>
              </thead>
              {DatatableContent}
            </table>
          </div>
          {PortletFooter}
        </div>
      </div>
    </div>
  );
}
